import React, { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import CommonSelect from 'components/controls/CommonSelect';
import { useOnUpdate } from 'js/customHooks'

export default function ProductsSelect() {
  const products = useSelector((state) => state.products);
  const product = useSelector((state) => state.product);
  const productUrls = useSelector((state) => state.productUrls);
  const dispatch = useDispatch();


  function getContent(){
    return {
      title:"Product",
      opts: products ? Object.keys(products).map((p) => ([products[p].id, products[p].name])) : [],
      buttons: [{className: (Object.keys(productUrls).length > 0) ? "Cat" : "CatDisabled", onClick: clickCatalogue},
                {className: (Object.keys(productUrls).length > 0) ? "Pro" : "ProDisabled", onClick: clickProduct}],
      current: product ? product : ""
    }
  }

  function getFuncs(){
    return {
      clickItem: clickItem
    }
  }

  const clickItem = (ev) => {
    dispatch({ type: 'SET_PRODUCT', payload: ev.target.textContent});
  }

  function clickCatalogue() {
    window.open(productUrls.cat, '_blank')
  }

  function clickProduct() {
    window.open(productUrls.pro, '_blank')
  }

  useEffect(() => { 
    console.log('render ProductsSelect')
  });

  return (
    <CommonSelect funcs={getFuncs()} content={getContent()} title="ID name of validated product" />
  )
}